// extracted by mini-css-extract-plugin
export default {"icon":"ThemeToggle_icon__PAsFp"};